import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import { AppBar, Backdrop, Grid, IconButton, Modal, Toolbar, Typography } from '@mui/material';
import Badge, { type BadgeProps } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import BasicButton from './BasicButton';
import MerchantForm from './createmerchants/MerchantForm';
import { useTranslation } from 'react-i18next';

const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  '& .MuiBadge-badge': {
    right: 7,
    top: 5,
    border: '1px solid',
    padding: '0 2px',
  },
}));
const AppBarHeader = () => {
  const [openForm, setOpenForm] = useState<boolean>(false);
  const { t } = useTranslation();

  return (
    <AppBar
      position='static'
      sx={{
        backgroundColor: 'white',
        borderRadius: '0px 0px 5px 5px',
        padding: '4px 0',
      }}
    >
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        open={openForm}
        onClose={() => setOpenForm(openForm)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <MerchantForm onClose={() => setOpenForm(false)} />
      </Modal>
      <Toolbar sx={{ minHeight: '50px !important'}}>
        <Typography
          // variant='h6'
          noWrap
          sx={{
            textAlign: 'left',
            width: '30%',
            color: '#16243D',
            fontWeight: 900,
            fontFamily: 'Nunito',
          }}
        >
          {t('header.title')}
        </Typography>
        <Grid
          sx={{
            display: 'flex',
            flexDirection: 'row',
            paddingLeft: '10px',
            width: '-webkit-fill-available',
          }}
        >
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              width: '-webkit-fill-available',
            }}
          >
            <BasicButton
              style={{
                margin: '0 20px',
                padding: '0 20px',
                height: '40px',
              }}
              text={t('header.newMerchant')}
              onClickEvent={() => setOpenForm(true)}
            />
            <IconButton aria-label='notifications' sx={{ border: '1px solid #E8E9EB', padding: '7px' }}>
              <StyledBadge
                color='error'
                badgeContent=' '
                variant='dot'
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
              >
                <NotificationsNoneIcon />
              </StyledBadge>
            </IconButton>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default AppBarHeader;
